export default __webpack_public_path__ + "static/media/connectedness-tree.b435a411.svg";